// Libraries
import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer'
import React from 'react'

import ResourceRow from '../../global/resourceRow'

// helpers
import formatInlineCode from '../../../utils/shortTextFormatting'
import Typography from '../../global/typography'

import { correctSlugPrefix } from '../../../utils/link.utils'
import { ResourceRowContainer } from './style'

type DynamicRowProps = {
  relatedResources: {
    slug?: string
    teaserBody?: string
    __typename?: string
    seoMetaData?: any
    spotlights?: any
    hero?: any
  }[]
  featuredResource?: any
  resourseRowIntro: string
  location: any
  locale?: string
}

const DynamicRow = ({
  relatedResources,
  featuredResource,
  resourseRowIntro,
  location,
  locale,
}: DynamicRowProps) => {
  if (relatedResources && relatedResources.length > 0) {
    const dynamicContent = relatedResources.map((resource: any, index: number) => {
      let slug: string = resource.slug || ''
      let teaserBody = resource.teaserBody || resource.seoMetadata?.pageMetaDescription
      if (resource.slug)
        resource['url1'] = `${location.origin || `https://www.uipath.com`}${correctSlugPrefix(
          slug
        )}`
      if (teaserBody) resource['body'] = teaserBody

      if (resource.__typename === 'ContentfulPageResourceDemo') {
        resource['title'] = resource.hero?.headline || ''
        resource['image'] =
          resource.spotlight && resource.spotlight.video ? resource.spotlight.video : {}
      } else if (resource.__typename === 'ContentfulTeaser') {
        let body = resource.body || ''
        let bodyText = ''
        if (body.raw) {
          bodyText = documentToPlainTextString(JSON.parse(body.raw))
        }
        resource.body = bodyText.slice(0, 255)
      }
      return resource
    })

    if (featuredResource && featuredResource.resource) {
      if (featuredResource.resource?.slug) {
        featuredResource.resource['url1'] = `${
          location.origin || `https://www.uipath.com`
        }${correctSlugPrefix(featuredResource.resource.slug)}`
      }
      let teaserBody =
        featuredResource.resource.teaserBody ||
        featuredResource.resource.seoMetadata?.pageMetaDescription

      if (featuredResource.resource.__typename === 'ContentfulTeaser') {
        let body = featuredResource.resource.body || ''
        const bodyText = documentToPlainTextString(JSON.parse(body.raw || ''))
        featuredResource.resource.body = bodyText.slice(0, 255) || ''
      } else {
        featuredResource.resource.body = teaserBody || ''
      }

      if (featuredResource.resource.__typename === 'ContentfulPageResourceDemo') {
        featuredResource.resource['image'] =
          featuredResource.resource.spotlight && featuredResource.resource.spotlight.video
            ? featuredResource.resource.spotlight.video
            : {}
        featuredResource.resource['title'] = featuredResource.resource?.hero?.headline || ''
      }
      dynamicContent.unshift(featuredResource.resource)
      dynamicContent.pop()
    }

    const dynamicRowData = {
      bottomPadding: 'Small',
      featuredPages: dynamicContent,
      topPadding: 'Small',
    }
    const defaultLocale = locale ? locale : 'en-US'
    return (
      <ResourceRowContainer data-cy={`RelatedResourceDynamicRow`}>
        <Typography className="ResourseRow_Intro" type="header2">
          {formatInlineCode(resourseRowIntro || '')}
        </Typography>
        <ResourceRow data={dynamicRowData} locale={defaultLocale}></ResourceRow>
      </ResourceRowContainer>
    )
  }
  return null
}

export default DynamicRow
